import { NavItem } from './item';
import type { MenuItem, NavigationProps } from '../types';
import s from './index.module.scss';

export const Navigation = ({ menu = [] }: NavigationProps): JSX.Element => {
  return (
    <div className={s.navigation}>
      {menu.map((item, idx) => {
        return item.path ? (
          <NavItem key={idx} item={item as MenuItem} />
        ) : (
          <div key={idx} className={s.divider} />
        );
      })}
    </div>
  );
};
